export const PASSWORD_ERROR_NECESSARY_USE = 'app.errors.passwordError.necessarilyUse'
export const PASSWORD_ERROR_MIN_AND_MAX_LENGHT = 'app.errors.passwordError.minAndMaxLength'
export const PASSWORD_ERROR_WITHOUT_SPACES = 'app.errors.passwordError.withoutSpaces'
export const PASSWORD_ERROR_WITH_UPPER_CASE = 'app.errors.passwordError.withUpperCase'
export const PASSWORD_ERROR_WITH_LOWER_CASE = 'app.errors.passwordError.withLowerCase'
export const PASSWORD_ERROR_AND = 'app.errors.passwordError.and'
export const PASSWORD_ERROR_AND_2 = 'app.errors.passwordError.and2'
export const PASSWORD_ERROR_WITH_NUMBER = 'app.errors.passwordError.withNumber'
export const PASSWORD_ERROR_USE_LATIN_LETTER = 'app.errors.passwordError.useLatinLetter'
export const PASSWORD_ERROR_LETTERS = 'app.errors.passwordError.letters'
export const PASSWORD_ERROR_SIGNS = 'app.errors.passwordError.signs'
export const PASSWORD_ERROR_MAY = 'app.errors.passwordError.may'
